import ImageOne from "../images/interior-1.jpg";
import ImageTwo from "../images/interior-2.jpg";

export const InfoData = [
  {
    heading: "Explore our beautiful homes",
    paragraphOne:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ac mi eu nulla pulvinar pellentesque et eget libero. ",
    paragraphTwo:
      "Nunc accumsan tempor pretium. Ut feugiat libero sit amet tempus facilisis. Sed at hendrerit lectus. Donec vehicula dignissim mi, ac volutpat augue accumsan quis. Pellentesque at iaculis felis.",
    buttonLabel: "View Homes",
    image: ImageOne,
    reverse: false,
    delay: 100,
  },
  {
    heading: "Modern Designs",
    paragraphOne:
      "Lorem ipsum dolor sit amet, consectetur adipiscing elit. Aliquam ac mi eu nulla pulvinar pellentesque et eget libero. ",
    paragraphTwo:
      "Nunc accumsan tempor pretium. Ut feugiat libero sit amet tempus facilisis. Sed at hendrerit lectus. Donec vehicula dignissim mi, ac volutpat augue accumsan quis. Pellentesque at iaculis felis.",
    buttonLabel: "View Homes",
    image: ImageTwo,
    reverse: true,
    delay: 300,
  },
];
